var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('FormModelDisplay',{attrs:{"singleton":"","entity-repository":_vm.footerRepository,"embeds":_vm.embeds,"i18n-group":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }